// extracted by mini-css-extract-plugin
export default {"Page":"Page_Page__BmUsj","hide_secondary_nav":"Page_hide_secondary_nav__J8Ci8"};